import { useEffect } from "react";
import { useState } from "react";
import { createContext } from "react";
import useAuthData from "../../../../../../hook/useAppData";
import { IEletronicInventory } from "../../Form/models";
import { getEletronic } from "../../service";
import { ListEletronicsStoreProps, StoreProviderProps } from "../models";

export const ListEletronicsStore = createContext({} as ListEletronicsStoreProps);

export function ListEletronicsStoreProvider({ children }: StoreProviderProps) {
  const { token } = useAuthData();
  const [listEletronic, setListEletronic] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [selectFilterValue, setSelectFilterValue] = useState(0);
  const [filterSelect, setFilterSelect] = useState(0);
  const [page, setPage] = useState(1);
  const [selectSize, setSelectSize] = useState(10);
  const [modalStatus, setModalStatus] = useState({ status: false, id: 0 });
  const [nameItem, setNameItem] = useState("");
  const [totalItens, setTotalItens] = useState("");
  const [inactiveOrActive, setInactiveOrActive] = useState(false);
  const [eletronicActived, setEtronicActived] = useState([]);
  const [eletronicInactived, setEletronicInactived] = useState([]);
  const [orderSwitch, setOrderSwitch] = useState(true);
  const [needSpinner, setNeedSpinner] = useState(true);

  useEffect(() => {
    getEletronics();
  }, []);

  useEffect(() => {
    setNeedSpinner(true);
    renderizar();
    setTimeout(() => {
      setNeedSpinner(false);
    }, 1000);
  }, [eletronicActived, eletronicInactived, inactiveOrActive]);

  function renderizar() {
    return inactiveOrActive ? eletronicInactived : eletronicActived;
  }

  async function getEletronics() {
    const data = await getEletronic(token);
    setListEletronic(data?.eletronics);
    setTotalItens(data?.total);
    const [eletronicActive, eletronicInactive] = separateActiveFromInactiveEletronics(data?.eletronics);
    setEtronicActived(eletronicActive);
    setEletronicInactived(eletronicInactive);
  }

  function separateActiveFromInactiveEletronics(list?: IEletronicInventory[]) {
    const listEletronics = list;
    const active = listEletronics?.filter((item) => Boolean(!item.isDeleted));
    const inactive = listEletronics?.filter((item) => Boolean(item.isDeleted));
    return [active, inactive];
  }

  return (
    <ListEletronicsStore.Provider
      value={{
        listEletronic,
        setListEletronic,
        filterValue,
        setFilterValue,
        selectFilterValue,
        setSelectFilterValue,
        filterSelect,
        setFilterSelect,
        page,
        setPage,
        selectSize,
        setSelectSize,
        modalStatus,
        setModalStatus,
        nameItem,
        setNameItem,
        totalItens,
        setTotalItens,
        getEletronics,
        inactiveOrActive,
        setInactiveOrActive,
        eletronicActived,
        setEtronicActived,
        eletronicInactived,
        setEletronicInactived,
        separateActiveFromInactiveEletronics,
        orderSwitch,
        setOrderSwitch,
        needSpinner,
        setNeedSpinner,
      }}
    >
      {children}
    </ListEletronicsStore.Provider>
  );
}
